import { createAction } from 'redux-actions';

export const fetchAppConfigRequest = createAction('FETCH_APP_CONFIG_REQUEST');
export const fetchAppConfigSuccess = createAction('FETCH_APP_CONFIG_SUCCESS');
export const fetchAppConfigFailure = createAction('FETCH_APP_CONFIG_FAILURE');

export const fetchAppConfig = () => async (dispatch) => {
  try {
    // if (localStorage.getItem("roleId") && localStorage.getItem("roleId") !== null) {
    // }

  } catch (error) {
    dispatch(fetchAppConfigFailure({ error }));
    throw error;
  }
};
